import Grid from "@mui/material/Grid";
import ActionCard from "components/ActionCard";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";

import placeholderImage from "assets/images/admin-actions/placeholder.jpg";

function AgentInstructionButtons() {
  const displayedCards = [
    {
      route: "/admin/agents/modify-instructions?agentNumber=1",
      image: placeholderImage,
      title: "Agent 1",
      description: "Bekijk en beheer de instructies van Agent 1",
    },
    {
      route: "/admin/agents/modify-instructions?agentNumber=2",
      image: placeholderImage,
      title: "Agent 2",
      description: "Bekijk en beheer de instructies van Agent 2",
    },
    {
      route: "/admin/agents/modify-instructions?agentNumber=3",
      image: placeholderImage,
      title: "Agent 3",
      description: "Bekijk en beheer de instructies van Agent 3",
    },
    {
      route: "/admin/agents/modify-instructions?agentNumber=4",
      image: placeholderImage,
      title: "Agent 4",
      description: "Bekijk en beheer de instructies van Agent 4",
    },
  ];

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={8}>
          <MKTypography variant="h3">Instructies Wijzigen</MKTypography>
          <MKTypography variant="body2" fontWeight="regular" color="text">
            Met deze drie-staps-flow kun je in het beheerpaneel per agent aparte instructies
            aanpassen en zo precies bepalen hoe elk onderdeel reageert.
          </MKTypography>
        </Grid>
        <Grid container spacing={3} rowGap={3} sx={{ mt: 3 }}>
          {displayedCards.map((card) => (
            <Grid item xs={12} md={6} lg={4} key={card.route}>
              <MKBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <ActionCard
                  route={card.route}
                  image={card.image}
                  title={card.title}
                  description={card.description}
                />
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default AgentInstructionButtons;
